<h3 mat-dialog-title>
    {{ 'Violation History - ' + (data.history.eventType | capitalize) }}
    <button mat-icon-button disableRipple mat-dialog-close><mat-icon>close</mat-icon></button>
</h3>

<mat-dialog-content>
    <div [innerHTML]="data.history.content"></div>
</mat-dialog-content>
